import React from 'react'
import { InformationCardProps } from './types'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import StyledList from '@toasttab/shared/src/components/molecules/StyledList/StyledList'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { Card, Text } from '@toasttab/shared/src/utils/craftUtils'
import classNames from 'classnames'
import { StyledListProps } from '@toasttab/shared/src/components/molecules/StyledList/StyledList.d'
import { Arrow } from '@toasttab/shared/src/components/molecules/TextLink/TextLinkIcons/TextLinkIcons'
import { renderRichText } from 'gatsby-source-contentful/rich-text'
import { InformationCardHeadingOptions } from '@toasttab/shared/src/utils/Contentful/richText'

const InformationCard = ({
  children,
  ctaLabel,
  ctaLink,
  elevation,
  icon,
  linkIcons,
  paddingMatrix,
  sectionDescription,
  sectionHeading,
  subtitle,
  textAlignment,
  toggleSwitch = false, // adds arrow to heading
  dataTestId = 'InformationCard-1'
}: InformationCardProps) => {
  const cardClasses = classNames(
    // information-card class is used only for custom styling within the SectionWrapper component
    'information-card bg-white rounded-md h-full block z-100',
    Text.alignment(textAlignment),
    Card.elevation(elevation),
    Card.cardPadding(paddingMatrix[0]),
    {
      'shadow-md': !elevation,
      'lg:hover:shadow-3xl': elevation === 'flat',
      'border border-solid border-card-light': elevation === 'flatNoHover'
    }
  )
  let El = 'div'

  const cardAttributes: any = {
    className: cardClasses,
    'data-testid': dataTestId
  }
  if (ctaLink && !ctaLabel) {
    cardAttributes.href = ctaLink
    El = 'a'
  }
  const linkIcon = (linkIcon: string) => {
    switch (linkIcon) {
      case 'Chevron Down':
        return 'chevron-down'
      case 'Download':
        return 'download'
      case 'arrowRight':
      case 'Right Arrow':
      default:
        return 'arrow'
    }
  }
  return (
    <El {...cardAttributes}>
      {icon?.length > 0 && (
        <Image
          {...icon[0]}
          imgClasses={`!w-auto max-h-[220px] mb-6 ${
            textAlignment === 'center' ? 'mx-auto' : ''
          }`}
        />
      )}
      {sectionHeading && (
        <Typography
          allowHtml={false}
          variation='h4'
          as='h4'
          classes={`text-default mb-4 !font-normal ${
            toggleSwitch ? 'group flex items-center' : ''
          }`}
        >
          {sectionHeading}
          {toggleSwitch && (
            <Arrow classes='ml-2 h-full stroke-gray-125 group-hover:translate-x-[7px] transition-all' />
          )}
        </Typography>
      )}
      {subtitle && (
        <p className='font-semibold pb-1' data-testid='subheading'>
          {subtitle}
        </p>
      )}
      {sectionDescription?.raw
        ? renderRichText(sectionDescription, InformationCardHeadingOptions)
        : null}
      {!sectionDescription?.raw && sectionDescription ? (
        <Typography as='p' classes='text-secondary'>
          {sectionDescription}
        </Typography>
      ) : null}
      {children?.length > 0 &&
        children.map(
          ({ id, listItems, listStyles }: StyledListProps, index: number) => (
            <StyledList
              id={id}
              listOnly
              listStyles={listStyles}
              listItems={listItems}
              listVariation='heading-only'
              key={`${id}-${index}`}
            />
          )
        )}
      {ctaLabel && ctaLink && (
        <TextLink
          classes={`mt-4 ${linkIcon(linkIcons)}`}
          href={ctaLink}
          icon={linkIcon(linkIcons)}
          text={ctaLabel}
        />
      )}
    </El>
  )
  // return (
  //   <El {...cardAttributes}>
  //     {icon?.length > 0 && (
  //       <Image {...icon[0]} imgClasses={`!w-auto mb-2 ${textAlignment === 'center' ? 'mx-auto' : ''}`} />
  //     )}
  //     {sectionHeading && (
  //       <Typography
  //         variation="h5"
  //         as="h5"
  //         classes={`text-default mb-2 ${toggleSwitch ? 'group flex items-center' : ''}`}
  //       >
  //         {sectionHeading}
  //         {toggleSwitch && <Arrow classes="ml-2 h-full stroke-gray-125 group-hover:translate-x-[7px] transition-all" />}
  //       </Typography>
  //     )}
  //     {subtitle && (
  //       <p className="font-semibold pb-1" data-testid="subheading">
  //         {subtitle}
  //       </p>
  //     )}
  //     {sectionDescription && (
  //       <p className="text-gray-100 pb-4" data-testid="description">
  //         {sectionDescription}
  //       </p>
  //     )}
  //     {children?.length > 0 &&
  //       children.map(({ id, listItems, listStyles }: StyledListProps) => (
  //         <StyledList
  //           id={id}
  //           listOnly
  //           listStyles={listStyles}
  //           listItems={listItems}
  //           listVariation="heading-only"
  //           key={id}
  //         />
  //       ))}
  //     {ctaLabel && ctaLink && <TextLink classes={`mt-4 ${linkIcons}`} href={ctaLink} icon="arrow" text={ctaLabel} />}
  //   </El>
  // )
}

export default InformationCard
